import * as api from '@/api/kzActivity/sign'
import * as TYPES from './type';

export default {
  // 课中活动签到
  async getSignList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSignList(paramets)
    commit(TYPES.SIGN_LIST, { result })
    cb && cb()
  },
  async getSignById({ commit, state }, { paramets, cb }) {
    const result = await api.reqSignById(paramets)
    commit(TYPES.SIGN_INFO, { result, type: 'detail' })
    cb && cb()
  },
  async delSignDel({ commit, state }, { paramets, cb }) {
    const result = await api.reqSignDel(paramets)
    commit(TYPES.SIGN_INFO, { result, type: 'del' })
    cb && cb()
  },
  async postSignEdit({ commit, state }, { paramets, cb }) {
    const result = await api.reqSignEdit(paramets)
    commit(TYPES.SIGN_INFO, { result, type: 'edit' })
    cb && cb()
  },
  async getImportSign({ commit, state }, { paramets, cb }) {
    const result = await api.reqImportSign(paramets)
    commit(TYPES.SIGN_INFO, { result, type: 'import' })
    cb && cb()
  },
}